export default __webpack_public_path__ + "static/media/chartresmini.47654dfb.jpg";